import { jsx as k } from "react/jsx-runtime";
import * as w from "react";
import { S as N } from "./index-DsTrtXZS.js";
import { cn as V } from "./utils.js";
function m(e) {
  var t, r, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (r = m(e[t])) && (a && (a += " "), a += r);
  else for (t in e) e[t] && (a && (a += " "), a += t);
  return a;
}
function C() {
  for (var e, t, r = 0, a = ""; r < arguments.length; ) (e = arguments[r++]) && (t = m(e)) && (a && (a += " "), a += t);
  return a;
}
const c = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, f = C, j = (e, t) => (r) => {
  var a;
  if ((t == null ? void 0 : t.variants) == null) return f(e, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  const { variants: l, defaultVariants: o } = t, g = Object.keys(l).map((n) => {
    const s = r == null ? void 0 : r[n], d = o == null ? void 0 : o[n];
    if (s === null) return null;
    const i = c(s) || c(d);
    return l[n][i];
  }), v = r && Object.entries(r).reduce((n, s) => {
    let [d, i] = s;
    return i === void 0 || (n[d] = i), n;
  }, {}), b = t == null || (a = t.compoundVariants) === null || a === void 0 ? void 0 : a.reduce((n, s) => {
    let { class: d, className: i, ...h } = s;
    return Object.entries(h).every((x) => {
      let [y, u] = x;
      return Array.isArray(u) ? u.includes({
        ...o,
        ...v
      }[y]) : {
        ...o,
        ...v
      }[y] === u;
    }) ? [
      ...n,
      d,
      i
    ] : n;
  }, []);
  return f(e, g, b, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
}, A = j(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 dark:focus-visible:ring-gray-300",
  {
    variants: {
      variant: {
        default: "bg-gray-900 text-gray-50 shadow hover:bg-gray-900/90 dark:bg-gray-50 dark:text-gray-900 dark:hover:bg-gray-50/90",
        destructive: "bg-red-500 text-gray-50 shadow-sm hover:bg-red-500/90 dark:bg-red-900 dark:text-gray-50 dark:hover:bg-red-900/90",
        outline: "border border-gray-200 bg-white shadow-sm hover:bg-gray-100 hover:text-gray-900 dark:border-gray-800 dark:bg-gray-950 dark:hover:bg-gray-800 dark:hover:text-gray-50",
        secondary: "bg-gray-100 text-gray-900 shadow-sm hover:bg-gray-100/80 dark:bg-gray-800 dark:text-gray-50 dark:hover:bg-gray-800/80",
        ghost: "hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-800 dark:hover:text-gray-50",
        link: "text-gray-900 underline-offset-4 hover:underline dark:text-gray-50"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), O = w.forwardRef(
  ({ className: e, variant: t, size: r, asChild: a = !1, ...l }, o) => /* @__PURE__ */ k(
    a ? N : "button",
    {
      className: V(A({ variant: t, size: r, className: e })),
      ref: o,
      ...l
    }
  )
);
O.displayName = "Button";
export {
  O as B,
  A as b
};
